<template>
	<div class="DqsHolder">
		<dqs
			class="DqsModule"
			:calculated-dqs="totalScore"
			:stroke-dash-array="totalPossibleScore"
			:stroke-color="strokeColor"
			:is-visible="dqsIsVisible"
		/>
		<span class="IconContainer">
			<tooltip :tooltip-message="determinantScoresMessage" />
		</span>
	</div>
</template>

<script>
import dqs from "@/components/dqs";
import tooltip from "@/components/tooltip";
import { dqsDefaultLogic } from "@/mixins/dqs-default-logic";
import dataAccessLayer from "@/data-access-layer/data-access-layer";

export default {
	name: "OneStudy",
	components: { dqs, tooltip },
	mixins: [dqsDefaultLogic],
		data: function() {
		return {
			determinantScoresMessage: '',
			dataAccessLayer
		}
	},
	created() {
		this.newApiUrl();
	},
	methods:{
		newApiUrl(){

			if(this.requestId === null){

				let dqsData = [];
				this.prepareTotalScore(dqsData);
				this.tooltipMessage(dqsData);
				return;
			}

			this.viewApiCall =  `${this.apiUrl}study?id=${this.requestId}`;

			this.apiCall();
		},
		async apiCall(){

			let dqsData = await dataAccessLayer.get(this.viewApiCall);

			if(dqsData.studyScores && dqsData.studyScores.length > 0){

				dqsData = dqsData.studyScores[0];
			}

			this.prepareTotalScore(dqsData);
			this.prepareDeterminantScores(dqsData);
		},
		prepareDeterminantScores(dqsData){

			if(dqsData.scores){

				this.determinantScores = dqsData.scores;
			}

			this.determinantScores = dqsData.scores;
			this.tooltipMessage(dqsData);
		},
		tooltipMessage(dqsData){

			if(!dqsData || dqsData.length === 0){

				this.determinantScoresMessage = '<p>There is no DQS for this study.</p>';
				return;
			}

			if(this.viewApiCall === ''){

				this.determinantScoresMessage = '<p>There is no DQS for this study.</p>';
				return;
			}

			if(dqsData.totalScore && (dqsData.totalScore.score === dqsData.totalScore.possibleScore)){

				this.determinantScoresMessage = '<p<i class="Icon lnr-gift"></i> Awesome! This study has the highest possible score 🔥</p>';
				return;
			}

			let snippet = '<p>To improve this score you might want to look into:</p> <ul>';
			snippet += this.createTooltipInnerMessage();
			snippet += '</ul>';
			this.determinantScoresMessage = snippet;
		},
		createTooltipInnerMessage(){

			let innerSnippet = '';
			this.determinantScores.forEach( (determinant) => {

				const attributeScore = determinant.score;
				const attributePossibleScore = determinant.possibleScore;

				if (attributeScore === attributePossibleScore) return ;

				const formattedAttribute = determinant.name.replace('_', ' ');
				innerSnippet += `<li>${formattedAttribute}</li>`;
			});

			return innerSnippet;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../styles/main';

.DqsHolder{
	display: -webkit-box;
	-webkit-box-align: center;
	align-items: center;
	height: 2.3rem;
	padding: 0.5rem 1.25rem;
	border-left: 1px solid $GreyLL;

	.DqsModule{
		width: 2.5rem
	}

	.IconContainer{
		margin-left: 0.5rem;
	}
}
</style>
